import React, { FunctionComponent } from 'react';
import { withRouter } from 'react-router';
import queryString from 'query-string';
import { LineSeries } from 'react-vis';
import { Grid } from 'semantic-ui-react';

import { theme } from 'config';
import ReportBase, { ReportParams } from 'scenes/Report/components/ReportBase';
import Query from 'scenes/Report/components/Query';
import BarChart from 'scenes/Report/components/BarChart/BarChart';
import MetricHeader from 'scenes/Report/components/MetricHeader';
import { WithRouterProps } from 'helpers/types';

import GET_CONTROL_GROUP from '../ControlGroupReports.queries';
import {
  lineTransformer,
  tickFormatYAxis,
} from '../ControlGroupReports.helpers';

type LiftResults = {
  transactionsPerUserLiftPercent: number;
  periodStart: string;
};

type QueryResponse = {
  controlGroup: {
    overallTransactionsPerUserLiftPercent: number;
    liftResults: LiftResults[];
  };
};

const legendItems = [
  {
    title: 'Frequency Lift Percent',
    color: theme.violet,
  },
];

type Props = WithRouterProps & {
  height?: number;
};

const renderReport = (params: ReportParams, { height = 450 }: Props) => ({
  controlGroup,
}: QueryResponse) => {
  const { liftResults = null, overallTransactionsPerUserLiftPercent = 0 } =
    controlGroup || {};

  const liftResultsData = liftResults || [];

  return (
    <ReportBase
      batchKey="frequencyLiftByDate"
      header="Frequency Lift By Date"
      params={params}
    >
      <>
        <Grid container>
          <Grid.Row columns="equal" centered>
            <MetricHeader lift={overallTransactionsPerUserLiftPercent} />
          </Grid.Row>
        </Grid>

        <BarChart
          title="Frequency Lift By Date"
          getAxis={{ x: 'periodStart', y: 'transactionsPerUserLiftPercent' }}
          height={height}
          tickFormatYAxis={tickFormatYAxis}
          data={liftResultsData}
          legendItems={legendItems}
          hintFormat=".1%"
          isDate
        >
          <LineSeries
            color={theme.seafoamGreen}
            strokeDasharray="7, 3"
            data={lineTransformer(
              overallTransactionsPerUserLiftPercent as number,
            )(liftResultsData as LiftResults[])}
          />
        </BarChart>
      </>
    </ReportBase>
  );
};

const FrequencyLiftByDate: FunctionComponent<Props> = (props) => {
  const params = queryString.parse(props.location.search) as ReportParams;

  return (
    <Query
      queryKey="controlGroup"
      reportName="Frequency Lift By Date"
      batchKey="frequencyLiftByDate"
      query={GET_CONTROL_GROUP}
      variables={{ params }}
      render={renderReport(params, props)}
    />
  );
};

export default withRouter(FrequencyLiftByDate);
